import React from "react";
import { useTranslation } from "react-i18next";
import { OrderPaymentMethodType } from "../../../../../../../../services/Api/Public/types";
import OrderPaymentMethod from "./OrderPaymentMethod";

interface Props {
	type: OrderPaymentMethodType;
	onClick(): void;
	selected: boolean;
}

const OrderPaymentMethodOption = ({ type, onClick, selected }: Props) => {
	const { t } = useTranslation();

	const getPaymentMethodName = () => {
		switch (type) {
			case OrderPaymentMethodType.APPLE_PAY:
				return t("enums.online_payments.APPLE_PAY");
			case OrderPaymentMethodType.GOOGLE_PAY:
				return t("enums.online_payments.GOOGLE_PAY");
			case OrderPaymentMethodType.BLIK:
				return t("enums.online_payments.BLIK");
			case OrderPaymentMethodType.BANK_TRANSFER:
				return t("enums.online_payments.BANK_TRANSFER");
			default:
				return "";
		}
	};

	const handleOnClick = () => {
		onClick();
	};

	return (
		<div onClick={handleOnClick} data-testid={`e-order-payment-method-option-${type}`}>
			<label className={`payment-option ${selected ? "selected" : ""}`}>
				<div className="payment-label">{getPaymentMethodName()}</div>
				<div className="payment-option-right">
					<OrderPaymentMethod paymentMethodType={type} />
					<input type="radio" name="paymentMethod" value="tpay" checked={selected} />
				</div>
			</label>
		</div>
	);
};

export default OrderPaymentMethodOption;
